export default {
  actions: {
    AddToBag(ctx, data) {
      return new Promise((resolve, reject) => {
        let dataToServer = {
          product_id: data.product_id,
          quantity: data.quantity,
          is_pre_order: data.is_pre_order,
          pre_order_price: data.pre_order_price,
          frame_number: data.frame_number
        };

        let url = data.path + '/carts';

        if (!!localStorage.getItem('cart_id')) {
          dataToServer.cart_id = localStorage.getItem('cart_id');
        }

        let headers = {
          'Content-Type': 'application/json'
        };

        if (!!localStorage.getItem('access_token')) {
          headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`
        }
        axios({
          method: 'POST',
          url: url,
          headers: headers,
          data: dataToServer
        }).then(response => {
          if (response.data.hasOwnProperty('cart_id')) {
            localStorage.setItem('cart_id', response.data.cart_id);
          }
          ctx.commit('updateCartCount', {count: 1, update: false});
          location.href = '/' + data.lang + '/cart';
          resolve({
            status: true,
            gtag: response.data.gtag || null
          });
        }).catch(error => {
          if (error.response.status === 400) {
            reject({
              message: error.response.data.message,
              exist: true
            })
          } else {
            reject({
              message: 'Server error. Please try later',
              exist: false
            })
          }
        })
      })
    },
    GetCartItems(ctx, data) {
      return new Promise((resolve, reject) => {
        if (!!localStorage.getItem('access_token')) {
          axios({
            method: 'POST',
            url: data.path + '/getAuthCarts',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('access_token')}`
            },
            data: {
              cart_id: localStorage.getItem('cart_id') || null,
              country_id: data.country_id || null
            }
          }).then(response => {
            if (!!response.data.cart.cart_items) {
              ctx.commit('updateCartItems', response.data.cart.cart_items);
              if (location.href.indexOf('/cart') !== -1) {
                Echo.channel(`cart.${response.data.cart.id}`)
                  .listen('RemoveFromCartAfterReservationEnded', (e) => {
                    location.reload()
                  });
              }
              if (location.href.indexOf('/checkout') !== -1) {
                Echo.channel(`cart.${response.data.cart.id}`)
                  .listen('RemoveFromCartAfterReservationEnded', (e) => {
                    ctx.commit('updateReservationEnded', true);
                  });
              }

              let total = response.data.cart.cart_items.reduce((total, item) => total += parseInt(item.quantity), 0);
              ctx.commit('updateCartCount', {count: total, update: true});
              resolve(response)
            }
            ctx.commit('updateCartLoadingStatus', false);
          }).catch(error => {
            if (error.response && error.response.status === 401) {
              localStorage.removeItem('access_token');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('user');
            }
            ctx.commit('updateCartLoadingStatus', false);
            reject(error)
          });
        } else if (!!localStorage.getItem('cart_id')) {
          axios({
            method: 'POST',
            data: {
              cart_id: localStorage.getItem('cart_id')
            },
            url: data.path + '/getCarts',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('access_token')}`
            }
          })
            .then(response => {
              if (response.data.hasOwnProperty('cart_items')) {
                ctx.commit('updateCartItems', response.data.cart_items);
                let total = response.data.cart_items.reduce((total, item) => total += parseInt(item.quantity), 0);
                ctx.commit('updateCartCount', {count: total, update: true});
                ctx.commit('updateCartLoadingStatus', false);
              }
              resolve(response)
            })
        } else {
          ctx.commit('updateCartItems', []);
          ctx.commit('updateCartLoadingStatus', false);
          ctx.commit('updateCartCount', {count: 0, update: true});
          reject(new Error('Something went wrong'))
        }
      })
    },
    DeleteFromBag(ctx, data) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'DELETE',
          url: data.path + '/carts/' + data.id,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
          }
        }).then(response => {
          ctx.commit('updateCartCount', {count: -data.quantity, update: false});
          ctx.commit('updateCartItemsById', data.id);
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    ChooseAnotherItems(ctx, data) {
      axios({
        method: 'POST',
        url: data.path + '/carts/update/choose-another',
        data: {
          cart_id: data.cart_id
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
      }).then(response => {
        location.href = response.data.link
      }).catch(error => {
        location.href = '/en/home'
      })
    },
    ChangeQuantity(ctx, data) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'PUT',
          url: data.path + '/carts/' + data.id,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
          },
          data: {
            quantity: data.quantity,
            product_id: data.product_id
          }
        })
          .then(response => {
            ctx.commit('updateCartCount', {count: response.data.quantity, update: false});
          }).catch(response => {
          reject(response);
        })
      });
    },
    Checkout(ctx, data) {
      let url = data.path + '/orders';

      if (!!localStorage.getItem('access_token')) {
        url = data.path + '/userOrder';
      }

      return new Promise((resolve, reject) => {
        axios({
          method: 'POST',
          url: url,
          data: data.data,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
          }
        })
          .then(response => {
            if (response.data.hasOwnProperty('token')) {
              localStorage.setItem('access_token', response.data.token.access_token);
            }
            resolve(response.data);
          }).catch(error => {
          reject(error);
        })
      });
    },
    ManualCheckout(ctx, data) {
      let url = `${data.path}/orders/${data.data.order_id}/${data.data.payment_id}/payment-link`;

      return new Promise((resolve, reject) => {
        axios({
          method: 'POST',
          url: url,
          data: data.data,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
          }
        })
          .then(response => {
            if (response.data.hasOwnProperty('token')) {
              localStorage.setItem('access_token', response.data.token.access_token);
            }
            resolve(response.data);
          }).catch(error => {
          reject(error);
        })
      });
    },
    GetOrders(ctx, data) {
      let url = data.path + '/client/orders';

      return new Promise((resolve) => {
        axios({
          method: 'GET',
          url: url,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
          }
        })
          .then(response => {
            ctx.commit('updateOrders', response.data);
            axios({
              method: 'GET',
              url: data.path + '/orderStatuses',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`
              }
            })
              .then(response => {
                ctx.commit('updateStatuses', response.data);
                resolve(response.data);
              });
          })
      });
    },
  },
  mutations: {
    updateReservationEnded(state, data) {
      state.reservationEnded = data;
    },
    updateCartCount(state, data) {
      if (!data.update && state.cartCount !== 0) {
        state.cartCount = parseInt(state.cartCount) + data.count;
      } else if (data.update) {
        state.cartCount = data.count;
      }
      if (state.cartCount > 9) {
        state.cartCount = '9+'
      } else {
        state.cartCount = parseInt(state.cartCount)
      }
    },
    updateCartItems(state, items) {
      state.cartItems = items
    },
    updateCartLoadingStatus(state, status) {
      state.cartLoadingStatus = status
    },
    updateCartItemsById(state, id) {
      state.cartItems = state.cartItems.filter(item => {
        return parseInt(item.id) !== parseInt(id);
      });
    },
    updateOrders(state, orders) {
      state.orders = orders
    },
    updateStatuses(state, statuses) {
      state.statuses = statuses
    },
  },
  state: {
    cartCount: 0,
    reservationEnded: false,
    cartItems: [],
    orders: [],
    statuses: [],
    cartLoadingStatus: true,
    isRunCheckout: !!localStorage.getItem('isRunCheckout')
  },
  getters: {
    getCartLoadingStatus(state) {
      return state.cartLoadingStatus
    },
    getReservationEnded(state) {
      return state.reservationEnded
    },
    getCartCount(state) {
      return state.cartCount
    },
    cartItems(state) {
      return state.cartItems
    },
    allOrders(state) {
      return state.orders
    },
    allStatuses(state) {
      return state.statuses
    },
    isRunCheckout(state) {
      return state.isRunCheckout
    }
  }
}
